function toggleTab() {
  const tabs = document.querySelectorAll(".toggle-tab");

  if (!tabs) return;

  tabs.forEach((tab) => {
    const opening = tab.querySelector(".toggle-opening");
    const opener = tab.querySelector(".toggle-opener");
    const svg = tab.querySelector("svg");
    const iframeMap = tab.querySelector(".iframe-map");
    if (!svg || !opener || !opening) return;

    svg.style.transition = "all 300ms";

    opener.addEventListener("click", () => {
      const isOpen = opening.classList.contains("grid-rows-[1fr]");

      if (isOpen) {
        opening.classList.replace("grid-rows-[1fr]", "grid-rows-[0fr]");
        svg.style.rotate = "0deg";
        if (!iframeMap) return;
        iframeMap.classList.replace("h-full", "h-0");
        iframeMap.classList.add("hidden");
      } else {
        opening.classList.replace("grid-rows-[0fr]", "grid-rows-[1fr]");
        svg.style.rotate = "180deg";
        if (!iframeMap) return;
        setTimeout(function () {
          iframeMap.classList.replace("h-0", "h-full");
          iframeMap.classList.remove("hidden");
        }, 600);
      }
    });
  });
}

toggleTab();
